import { render, staticRenderFns } from "./Payslipdetail.vue?vue&type=template&id=71a0d8a1"
import script from "./Payslipdetail.vue?vue&type=script&lang=js"
export * from "./Payslipdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports